<template>
  <!-- eslint-disable max-len -->
  <svg
    width="36px"
    height="60px"
    viewBox="0 0 36 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Phone Icon</title>
    <desc>Phone Icon</desc>
    <defs>
      <polygon points="0 0.249428571 35.2670536 0.249428571 35.2670536 59.1428571 0 59.1428571" />
    </defs>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g transform="translate(-797.000000, -359.000000)">
        <g>
          <g transform="translate(479.000000, 267.000000)">
            <g transform="translate(318.000000, 92.000000)">
              <g>
                <g transform="translate(0.000000, 0.608143)">
                  <mask fill="white">
                    <use xlink:href="#path-1" />
                  </mask>
                  <g />
                  <path
                    d="M6.06091518,4.53428571 C5.05747768,4.53428571 4.24064732,5.35885714 4.24064732,6.37285714 L4.24064732,53.0185714 C4.24064732,54.0325714 5.05747768,54.8571429 6.06091518,54.8571429 L29.2069866,54.8571429 C30.2104241,54.8571429 31.0264063,54.0325714 31.0264063,53.0185714 L31.0264063,6.37285714 C31.0264063,5.35885714 30.2104241,4.53428571 29.2069866,4.53428571 L6.06091518,4.53428571 Z M29.2069866,59.1428571 L6.06091518,59.1428571 C2.71895089,59.1428571 -0.000424107143,56.3957143 -0.000424107143,53.0185714 L-0.000424107143,6.37285714 C-0.000424107143,2.99571429 2.71895089,0.248571429 6.06091518,0.248571429 L29.2069866,0.248571429 C32.5489509,0.248571429 35.2674777,2.99571429 35.2674777,6.37285714 L35.2674777,53.0185714 C35.2674777,56.3957143 32.5489509,59.1428571 29.2069866,59.1428571 L29.2069866,59.1428571 Z"
                    :fill="active ? '#333366' : '#999999'"
                    mask="url(#mask-2)"
                  />
                </g>
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="2.28084821 56.4998571 32.9879018 56.4998571 32.9879018 50.2992857 2.28084821 50.2992857"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="2.28084821 8.17842857 32.9879018 8.17842857 32.9879018 3.57128571 2.28084821 3.57128571"
                />
                <path
                  d="M19.9628929,55.0032 C19.9628929,56.3034857 18.9204375,57.3569143 17.6336964,57.3569143 C16.3478036,57.3569143 15.3053482,56.3034857 15.3053482,55.0032 C15.3053482,53.7029143 16.3478036,52.6503429 17.6336964,52.6503429 C18.9204375,52.6503429 19.9628929,53.7029143 19.9628929,55.0032"
                  fill="#FEFEFE"
                />
                <polygon
                  fill="#FEFEFE"
                  points="13.1329018 5.57957143 22.1358482 5.57957143 22.1358482 4.07957143 13.1329018 4.07957143"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="8.22852679 24.1787143 27.2073214 24.1787143 27.2073214 14.2855714 8.22852679 14.2855714"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="8.22852679 30.6972857 27.2073214 30.6972857 27.2073214 29.0901429 8.22852679 29.0901429"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="8.22852679 35.4055714 27.2073214 35.4055714 27.2073214 33.7984286 8.22852679 33.7984286"
                />
                <polygon
                  :fill="active ? '#333366' : '#999999'"
                  points="8.22852679 40.1138571 27.2073214 40.1138571 27.2073214 38.5067143 8.22852679 38.5067143"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgPhone',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
